import React, { useState, useRef, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
  Box,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { fetchSuppliersByCompanyId } from "../../../../redux/orderSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updatePendingCompany } from "../../../../redux/adminSlice";

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
const allDigitsSame = (value) => /^(.)\1+$/.test(value);
export const ADD_EDIT_REFRRED_BY = yup.object().shape({
  referredName: yup
    .string()
    .matches(/^[a-zA-Z ]*$/, "Name must contain only alphabets and spaces."),
  referredCompanyName: yup
    .string()
    .test(
      "english-characters-only",
      "Please enter English characters only",
      (value) => !value || !nonEngChar.test(value)
    ),
  referredEmail: yup
    .string()
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
      "Invalid email format. Example: example@example.com"
    )
    .max(255, "Email must be at most 255 characters long."),
  referredPhone: yup
    .string()
    .matches(/^[0-9]+$/, "Phone number must only contain digits.")
    .test(
      "notAllDigitsSame",
      "All digits cannot be the same.",
      (value) => !allDigitsSame(value)
    ),
});

const EditPendingRefrredBy = ({
  onSubmit,
  handleStepChange,
  actionType,
  currentStep,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {createdDate, modifiedDate, rejectedReason,rejectedDate,isActive, companyLogo, user,firstName,lastName,prefix,...rest } = location.state?.pendingCompanyDetails || {};
  delete rest.createdDate;
  delete rest.modifiedDate;
  delete rest.rejectedReason;
  delete rest.rejectedDate;
  delete rest.isActive;
  delete rest.companyLogo;
  delete rest.user;
  delete rest.firstName;
  delete rest.lastName;
  delete rest.prefix;
  const initialValues = location.state?.pendingCompanyDetails || {};
  // const defaultValues = {
  //     referredName: '',
  //     referredCompanyName: '',
  //     referredEmail: '',
  //     referredPhone: '',
  //     ...rest
  // }
  // const editValue = (actionType === 'edit' || location.state?.actionType === 'edit') ? {
  //     address: ''
  // } : defaultValues;
  // const ISDList = useSelector(state => state.order.suppliers.data || []);
  // const stateList = useSelector(state => state.order.suppliers.data || []);
  // const cityList = useSelector(state => state.order.suppliaers.dta || []);
  const { loading } = useSelector((state) => state.order);
  const handleRefrredsubmit = (values) => {
    console.log("handleRefrredsubmit", values);
    const companyData = values;
    dispatch(updatePendingCompany(companyData))
      .then((response) => {
        const companyDetails = response.payload

        if (companyDetails.success === true) {
          navigate(-1);
        } 
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
  };
  return (
    <>
      <div className={className}>
      <div className="main-content">
                    <nav aria-label="breadcrumb" className="bread-box">
                        <div>
                            <h1 className="fprimary">
                                {location.state?.actionType === "edit" ? "Edit company" : "Add company"}
                            </h1>
                            <h5 className="">
                                {location.state?.actionType === "edit" ? "Edit" : "Add"} Company details to create
                                a new company
                            </h5>
                        </div>
                        <div>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="#">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    {location.state?.actionType === "edit" ? "Edit" : "Add"} Company
                                </li>
                            </ol>
                        </div>
                    </nav>
                    <div className="card mt-3 bg-stage">
        <Formik
          // initialValues={editValue || defaultValues}
          initialValues={{
            referredName: initialValues.referredName || "",
            referredCompanyName: initialValues.referredCompanyName || "",
            referredEmail: initialValues.referredEmail || "",
            referredPhone: initialValues.referredPhone || "",
            ...rest,
          }}
          enableReinitialize={true}
          validationSchema={ADD_EDIT_REFRRED_BY}
          onSubmit={(values, { setSubmitting }) => {
            if (location.state?.actionType === "edit") {
              handleRefrredsubmit({ ...values });
            }
            // console.log('AddEditlocation Submit:', values);
            // onSubmit(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            touched,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="card-body m-3">
                <div className="row">
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.rename")}
                      className="md-input"
                      name="referredName"
                      value={values.referredName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredName}
                      helperText={errors.referredName}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.recompany")}
                      className="md-input"
                      name="referredCompanyName"
                      value={values.referredCompanyName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredCompanyName}
                      helperText={errors.referredCompanyName}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.remail")}
                      className="md-input"
                      name="referredEmail"
                      value={values.referredEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredEmail}
                      helperText={errors.referredEmail}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.rephone")}
                      className="md-input"
                      name="referredPhone"
                      value={values.referredPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredPhone}
                      helperText={errors.referredPhone}
                    />
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-light grey-btn lg-btn"
                      onClick={() => navigate(-1)}
                    >
                      {t("createOrder.back")}
                    </button>
                    {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                Create Order
                
            </Button> */}
                    <button
                      className="btn btn-primary greeen-btn lg-btn"
                      type="submit"
                      variant="contained"
                      // onClick={handleSubmit} // Use onClick to trigger form submission
                      // disabled={ isValid || isSubmitting }
                    >
                      {/* Create Order */}
                      {loading ? "Submitting..." : "Submit"}
                      {/*  t('createOrder.createOrderbtn') */}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      </div>
      </div>
    </>
  );
};

export default EditPendingRefrredBy;
